// src/components/Head.tsx
import { Helmet } from 'react-helmet-async';

interface HeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  keywords?: string;
  author?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleSection?: string;
  articleTags?: string[];
}

const Head = ({
  title = 'Kamen d.o.o. - Keramika, kamen in pulti za vaš dom',
  description = 'Ponudba keramike, kamna in pultov za kuhinjo in kopalnico. Kakovostni materiali in strokovna izvedba za vaš dom.',
  canonical,
  ogImage = '/assets/images/opengraph-image.png',
  ogType = 'website',
  keywords = 'keramika, kamen, pulti, kuhinja, kopalnica, granit, marmor, keramične ploščice',
  author = 'Kamen d.o.o.',
  articlePublishedTime,
  articleModifiedTime,
  articleSection,
  articleTags
}: HeadProps) => {
  const currentUrl = canonical || window.location.href;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Article specific metadata for blog posts */}
      {ogType === 'article' && articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {ogType === 'article' && articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}
      {ogType === 'article' && articleSection && (
        <meta property="article:section" content={articleSection} />
      )}
      {ogType === 'article' && articleTags && articleTags.length > 0 && 
        articleTags.map((tag, index) => (
          <meta key={index} property="article:tag" content={tag} />
        ))
      }
    </Helmet>
  );
};

export default Head;